import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const Blocked = () => {
  return (
    <>
      <Text.Header2>
        {i18n.t('payroll_integrations.incidences.a3innuva.leave.blocked.title')}
      </Text.Header2>
      <Box>{i18n.t('payroll_integrations.incidences.a3innuva.leave.blocked.message')}</Box>
    </>
  )
}

export default Blocked
